import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const NameAndBadgeWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${Spacing.S16};
  cursor: pointer;
`
